commonModule.factory('commonTLCService', ['$http','AppSettings','userAuthenticateService', 'commonRESTCallService',
    'statesCacheService', '$q', 'imSessionVarsService', 'erateSessionVarsService', 'erateService',
    function ($http, AppSettings, userAuthenticateService, commonRESTCallService,
              statesCacheService, $q, imSessionVarsService, erateSessionVarsService, erateService) {
    var commonTLCService = {};

    //returns the list of all provider States
    commonTLCService.getStates = function()
    {
        var deferred = $q.defer(),
            myToken,
            states = statesCacheService.getCachedStates();

        if (states && states.length) {
            deferred.resolve(states)
        } else {
            myToken = userAuthenticateService.getUserToken(),
            commonRESTCallService.getFromServerWithToken(
                    AppSettings.startIdentitySvcURL + 'providers/states',
                    myToken
                )
                .success(function (response) {
                    statesCacheService.setCachedStates(response);
                    deferred.resolve(response);
                })
                .error(function (response, status, headers, config) {
                    deferred.reject(response);
                });
        }
        return deferred.promise;
    };

    commonTLCService.encryptNumeric = function(num)
    {
        var deferred = $q.defer();
        deferred.resolve(num)
        /*
        var myToken = userAuthenticateService.getUserToken();

        commonRESTCallService.getFromServerWithToken(
            AppSettings.startSPANPlusSvcURL + 'enchelper/formatnumber/' + num,
            myToken
        )
        .success(function (response, status, headers) {
            deferred.resolve(response);//first user found
        })
        .error(function (response, status, headers, config) {
            deferred.reject(new Error(status + ' ' + response));
        });
        */
        return deferred.promise;
    };


    commonTLCService.setupEssentialDealerVars = function(dealerInfo) {
        // Sync IM and ERATE session vars to whatever is in DB.
        // Next two should probably return a rejected promise, not throw.  Done this way for backward compatibility
        if (!dealerInfo.accountCode){
            throw "ACCOUNT-NOT-FOUND";
        }

        if (!dealerInfo.spanId) {
            throw "SPANID-NOT-FOUND";
        }

        // This may already be set, but it won't hurt if we do it again
        imSessionVarsService.setCurrentDealerIMId(dealerInfo.id);
        imSessionVarsService.setCurrentDealerIMName(dealerInfo.name);
        erateSessionVarsService.setCurrentDealerAccountCode(dealerInfo.accountCode);
        erateSessionVarsService.setDealerAltFinanceEnabled(false); // will sync to DB value below
        erateSessionVarsService.setDealerState(dealerInfo.state);
        erateSessionVarsService.setCurrentDealerMenuProId(dealerInfo.menuProId || '0');
        return commonTLCService.encryptNumeric(dealerInfo.spanId)
            .then(function(encval){
                erateSessionVarsService.setCurrentDealerSPANId(encval);
                return erateService.getSpanDealership(encval)
            })
            .then(function(dealership) {
                    erateSessionVarsService.setCurrentDealerVehicleType(dealership.vehicleType!=null ? dealership.vehicleType : 'AUTO');
                    erateSessionVarsService.setDealerAltFinanceEnabled(dealership.altFinance);
                    return true; // resolve
            });
    };


    return commonTLCService;
}]);
